module.exports = __webpack_public_path__ + "static/media/BNB.7061f8fd.svg";